'use strict';

(function () {
      document.addEventListener('DOMContentLoaded', () => {
            const buttons = document.querySelectorAll('.fes-building-list__item');
            const items = document.querySelectorAll('.fes-shop__item');
      
            // 現在選択されているカテゴリ
            let activebuilding = null;

            buttons.forEach(button => {
                  button.addEventListener('click', () => {
                        const building = button.dataset.building;

                        // ボタンの選択状態をリセット
                        if (activebuilding === building) {
                              // 同じカテゴリを再度クリックした場合は選択解除
                              activebuilding = null;
                              button.classList.remove('is-active');
                        } else {
                              // 他のカテゴリが選択されていたらリセット
                              buttons.forEach(btn => btn.classList.remove('is-active'));
                              activebuilding = building;
                              button.classList.add('is-active');
                        }

                        // 全アイテムを非表示
                        items.forEach(item => item.classList.remove('is-show'));

                        // 遅延して表示処理を実行
                        setTimeout(() => {
                              if (!activebuilding) {
                                    // すべてのボタンからis-activeがなくなった場合
                                    const noActiveButton = Array.from(buttons).every(btn => 
                                          !btn.classList.contains('is-active')
                                    );
                                    if (noActiveButton) {
                                          // 全てのボタンをアクティブ状態にする
                                          buttons.forEach(btn => btn.classList.add('is-active'));
                                          // 全アイテムを表示
                                          items.forEach(item => item.classList.add('is-show'));
                                    }
                              } else {
                                    // 選択されているカテゴリに応じて表示
                                    items.forEach(item => {
                                          const itemCategories = item.dataset.building.split(',');
                                          if (itemCategories.includes(activebuilding)) {
                                                item.classList.add('is-show');
                                          }
                                    });
                              }
                        }, 100); // 遅延
                  });
            });

            // 初期状態はすべて表示
            items.forEach(item => item.classList.add('is-show'));
      });
})();
